/* ==========================================================================
   COMPOUND — progressive enhancement
   Small, dependency-free behaviours layered onto Dawn.
   ========================================================================== */
(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     Header: transparent over the home hero, solid once scrolled past it.
     On the home template the header is fixed and overlays the hero (white
     text). After scrolling beyond the hero we add `.compound-scrolled` to
     <body> so the header flips to the solid paper/ink treatment.
     ---------------------------------------------------------------------- */
  function initHeaderOverlay() {
    var body = document.body;
    if (!body.classList.contains('template-index')) return;

    var header = document.querySelector('.section-header');

    function update() {
      var hero = document.querySelector('[data-compound-hero]');
      var headerH = header ? header.offsetHeight : 56;
      var trigger = hero ? hero.offsetHeight - headerH : window.innerHeight * 0.85;
      body.classList.toggle('compound-scrolled', window.scrollY > trigger);
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  /* ----------------------------------------------------------------------
     Shop: client-side Type filter (All / Warm Up / Performance / Recovery).
     Shows/hides the loaded grid items by their data-compound-type tags.
     Instant, matches the reference; operates on the current page of results.
     ---------------------------------------------------------------------- */
  function initTypeFilter() {
    var bar = document.querySelector('[data-compound-filters]');
    if (!bar) return;
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    function apply(f) {
      var items = grid.querySelectorAll('.grid__item');
      items.forEach(function (item) {
        var types = (item.getAttribute('data-compound-type') || '').split(/\s+/);
        var show = f === 'all' || types.indexOf(f) !== -1;
        item.hidden = !show;
      });
      bar.querySelectorAll('.cf').forEach(function (btn) {
        btn.classList.toggle('is-on', btn.getAttribute('data-f') === f);
      });
    }

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('.cf');
      if (!btn) return;
      apply(btn.getAttribute('data-f'));
    });

    // Auto-apply from ?type=warm|perf|rec (lets the Shop nav dropdown deep-link).
    var param = new URLSearchParams(window.location.search).get('type');
    if (param && bar.querySelector('.cf[data-f="' + param + '"]')) {
      apply(param);
    }
  }

  /* ----------------------------------------------------------------------
     PDP: self-contained tabs (Product information / Shipping & returns).
     Scoped per [data-compound-tabs] block — no sibling coupling.
     ---------------------------------------------------------------------- */
  function initTabs() {
    document.querySelectorAll('[data-compound-tabs]').forEach(function (root) {
      var btns = root.querySelectorAll('.compound-tabs__btn');
      var panels = root.querySelectorAll('.compound-tabs__panel');
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.compound-tabs__btn');
        if (!btn) return;
        var idx = btn.getAttribute('data-tab');
        btns.forEach(function (b) {
          b.classList.toggle('is-on', b === btn);
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-panel') !== idx;
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     Countdown timers (lock page drop + per-product release).
     Any [data-compound-countdown] with a parseable data-target ISO date
     ticks every second into its [data-cd] fields; flips to .is-live at zero.
     ---------------------------------------------------------------------- */
  function initCountdowns() {
    document.querySelectorAll('[data-compound-countdown]').forEach(function (el) {
      var target = Date.parse(el.getAttribute('data-target'));
      if (isNaN(target)) return;
      var f = {
        days: el.querySelector('[data-cd="days"]'),
        hours: el.querySelector('[data-cd="hours"]'),
        mins: el.querySelector('[data-cd="mins"]'),
        secs: el.querySelector('[data-cd="secs"]'),
      };
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var timer;
      function set(d, h, m, s) {
        if (f.days) f.days.textContent = pad(d);
        if (f.hours) f.hours.textContent = pad(h);
        if (f.mins) f.mins.textContent = pad(m);
        if (f.secs) f.secs.textContent = pad(s);
      }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          set(0, 0, 0, 0);
          el.classList.add('is-live');
          clearInterval(timer);
          return;
        }
        set(
          Math.floor(diff / 86400000),
          Math.floor((diff % 86400000) / 3600000),
          Math.floor((diff % 3600000) / 60000),
          Math.floor((diff % 60000) / 1000)
        );
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  function init() {
    initHeaderOverlay();
    initTypeFilter();
    initTabs();
    initCountdowns();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
